module.exports = __webpack_public_path__ + "static/img/HYGR_logo.4d86c85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/HYGR_logo.png
// module id = HVA/
// module chunks = 0